<template>
    <button :disabled="disabled" :class="{'fill-x': fill, 'square': square, ['bg-' + color]: color, [size]: size}" @click="onClick()">
      <div class="button-icon" v-if="icon">
        <AppIcon :name="icon" />
      </div>
      <span class="button-text" v-if="!square"><slot></slot></span>
      <AppLoader v-if="loading" size="small" color="white" style="margin-left: .5rem;" />
    </button>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '@/components/atoms/AppIcon.vue'

export default defineComponent({
  name: 'AppButton',
  components: { AppIcon },
  props: {
    icon: String,
    fill: Boolean,
    color: String,
    disabled: Boolean,
    loading: Boolean,
    size: String,
    to: String
  },
  setup(props, { slots }) {
    const router = useRouter()
    const square = ref(!slots.default)     

    function onClick() {
      props.to && router.push(props.to)
    }

    return { square, onClick }
  }
})
</script>

<style lang="scss" scoped>
  button {
    background: none;
    color: inherit;
    display: inline-flex;
    align-items: center;
    user-select: none;
    border: 0;
    height: 2.5rem;
    line-height: 2.5rem;
    letter-spacing: .25px;
    padding: 0 1rem;
    font-weight: 500;
    border-radius: 1rem;
    outline: 0;
    transition: all .2s;
    position: relative;
    font-size: 1rem;
    white-space: nowrap;
    touch-action: manipulation;

    .button-text {
      text-decoration: none !important;
      text-align: inherit;
    }

    &:before {
      content: "";
      transition: opacity .2s;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.05);
      opacity: 0;
      border-radius: 1rem;
    }

    &:hover {
      cursor: pointer;
      &:before {
        opacity: 1;
      }
    }

    &:active {
        transform: scale(.95);
        opacity: 0.75;
    }
    &:focus:before {
      content: '';
      pointer-events: none;
      border: .125rem solid rgba(0,0,0,0.15);
      opacity: 1;
    }
    &:disabled {
      opacity: 0.33;
      pointer-events: none;
      cursor: default;
    }

    &.fill {
      width: 100%;
    }
    
    &.bg-primary {
      &:hover {
        box-shadow: 0 .25rem 1rem #0066ff63;
      }
      .button-icon {
        color: var(--color-on-primary) !important;
      }
    }

    &.large {
      font-size: 1.25rem;
      height: 3.5rem;
      padding: 0 3rem;
    }

    &.square {
      width: 2.5rem;
      flex: 2.5rem 0 0;
      justify-content: center;
      padding: 0;
      color: var(--text-color-secondary);
      .button-icon {
        margin: 0;
      }
    }

    .button-icon {
      display: inline;
      border-radius: 1rem;
      padding: .75rem;
      margin-left: -1rem;
    }
  }


@media only screen and (max-width: 640px) {
  button.button-icon-on-mobile {
    padding-right: 0;
    .button-text {
      display: none;
    }
  }
}
    

</style>